export interface IAutocompleteData {
	value: any;
	label: string;
}

export class AutocompleteControlData {
	controlId: string;
	data: IAutocompleteData[];
	replaceAll?: boolean = false;
}
